var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f29400",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeOpacity: 1,
    strokeWidth: 1.022,
    d: "M63.412 3.675a29.537 29.537 0 00-29.538 29.537A29.537 29.537 0 0063.412 62.75a29.537 29.537 0 0029.537-29.537A29.537 29.537 0 0063.412 3.675zm6.826 12.819a9.892 9.892 0 019.892 9.892 9.892 9.892 0 01-9.892 9.89 9.892 9.892 0 01-9.89-9.89 9.892 9.892 0 019.89-9.892z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0c000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeOpacity: 1,
    strokeWidth: 1.022,
    d: "M63.393.07a29.537 29.537 0 00-29.538 29.537 29.537 29.537 0 0029.538 29.538A29.537 29.537 0 0092.93 29.607 29.537 29.537 0 0063.393.07zm6.826 12.819a9.892 9.892 0 019.892 9.892 9.892 9.892 0 01-9.892 9.89 9.892 9.892 0 01-9.89-9.89 9.892 9.892 0 019.89-9.892z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0c000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeOpacity: 1,
    strokeWidth: 1.045,
    d: "M51.611 27.414L.55 78.551v13.857h6.814l8.653-8.666-2.026-5.52 5.639 1.901L61.95 37.738z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f29400",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeOpacity: 1,
    strokeWidth: 1.045,
    d: "M54.96 31.207L.55 85.701v6.707H14.5l3.434-3.44-3.944-10.745 10.98 3.7 3.403-3.407v-7.092h7.082l29.848-29.89z",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0c000",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    strokeOpacity: 1,
    strokeWidth: 1.052,
    d: "M44.533 48.477l-30.09 29.898 5.16 1.74 28.362-28.183zm-30.38 30.187L.548 92.18v.228H7.23l8.768-8.713z",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.c76e9f2a2d7adea3ac8b36cfcaa4c882.svg";
export { ForwardRef as ReactComponent };